module.exports = __webpack_public_path__ + "img/sc-01-3.cf275972.jpg";